
import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="bg-primary min-h-screen pt-32 sm:pt-48 pb-24 px-6 overflow-hidden">
      <div className="max-w-3xl mx-auto reveal reveal-up active">
        <h1 className="text-4xl sm:text-7xl font-serif font-bold uppercase accent-text-gradient tracking-widest mb-12">Terms of Service</h1>
        
        <div className="space-y-12 text-white/60 leading-relaxed font-light text-lg">
          <section>
            <h2 className="text-white text-xl font-serif font-bold uppercase tracking-widest mb-4">1. Acceptance of Terms</h2>
            <p>By accessing or using the Santi Bladez website and booking services, you agree to be bound by these terms. If you do not agree, please do not use the service.</p>
          </section>

          <section>
            <h2 className="text-white text-xl font-serif font-bold uppercase tracking-widest mb-4">2. Concierge Appointments</h2>
            <p>All appointments are subject to availability. Santi Bladez reserves the right to refuse service for any reason. Cancellations must be made at least 24 hours in advance to avoid a cancellation fee.</p>
          </section>

          <section>
            <h2 className="text-white text-xl font-serif font-bold uppercase tracking-widest mb-4">3. House Call Requirements</h2>
            <p>For mobile services, the client must provide a safe environment with adequate lighting and a standard power outlet. Santi provides all professional tools and chairs.</p>
          </section>

          <section>
            <h2 className="text-white text-xl font-serif font-bold uppercase tracking-widest mb-4">4. Limitation of Liability</h2>
            <p>Santi Bladez is not liable for any indirect or consequential damages arising from the use of our mobile services.</p>
          </section>

          <section className="pt-12 border-t border-white/5">
            <p className="text-xs uppercase tracking-widest font-black text-accent/40">Last Updated: October 2024</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
